module.exports = __webpack_public_path__ + "img/guanyu_peisong@2x.453c2ca6.png";